// /src/pages/private/members/calendarMentionNavContext.js
// Exposes the occurrence id selected on the member calendar page so chat (deep in the tree)
// can attach calendarOccurrenceId to create-mention even when intermediate props omit it.

import { createContext } from "react";

export const CalendarMentionNavContext = createContext(null);
